export const defaults = {
    icon: 'images',       // Icon für den Button
    disable: true,        // Soll das Input neben dem Button deaktiviert werden?
};
